'use es6';

import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import withDisabledContext from '../../hoc/withDisabledContext';
import GroupedFontSelect from './GroupedFontSelect';
import { FontStyledUITextToolbarSelect, FontVariantButton, FontVariantOption, FontVariantSelect } from './StyledComponents';
import { jsx as _jsx } from "react/jsx-runtime";
function StyledFontSelect(props) {
  const rest = Object.assign({}, (_objectDestructuringEmpty(props), props));
  return /*#__PURE__*/_jsx(GroupedFontSelect, Object.assign({
    StyledUITextToolbarSelectComponent: FontStyledUITextToolbarSelect,
    VariantButtonComponent: FontVariantButton,
    VariantOptionComponent: FontVariantOption,
    VariantSelectComponent: FontVariantSelect
  }, rest));
}
export default withDisabledContext(StyledFontSelect);